import React from 'react'

export default function EditButton({ onClick, size }) {
  const handleEditClick = () => {
    onClick()
  }

  return (
    <button onClick={handleEditClick}>
      <svg
        id="edit-icon"
        data-name="Edit"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 110 135"
        width={size}
        height={size}
        className="inline-block ml-2"
      >
        <path
          className="cls-1"
          d="M23.8,102.2h53.1c6,0,10.9-4.9,10.9-10.9v-24.3c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1v24.3c0,2.6-2.1,4.7-4.7,4.7H23.8c-2.6,0-4.7-2.1-4.7-4.7v-53.1c0-2.6,2.1-4.7,4.7-4.7h24.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-24.3c-6,0-10.9,4.9-10.9,10.9v53.1c0,6,4.9,10.9,10.9,10.9h0Z"
        />
        <path
          className="cls-1"
          d="M31.2,67.7l-3.1,13.5c-.4,1.6.1,3.2,1.3,4.4.9.9,2.1,1.4,3.3,1.4s.7,0,1.1-.1l13.5-3.1c.6-.1,1.1-.4,1.5-.8l45.7-45.7c3.1-3.1,3.1-8.1,0-11.2l-5.6-5.6c-1.5-1.5-3.5-2.3-5.6-2.3s-4.1.8-5.6,2.3l-7.1,7.1s0,0,0,0c0,0,0,0,0,0l-38.6,38.6c-.4.4-.7.9-.8,1.5h0ZM36,74.6l4.3,4.3-5.6,1.3,1.3-5.6ZM72.8,34.3l7.9,7.9-34.2,34.2-7.9-7.9,34.2-34.2ZM82.1,24.9c.6-.6,1.7-.6,2.3,0l5.6,5.6c.6.6.6,1.7,0,2.3l-4.9,4.9-7.9-7.9,4.9-4.9Z"
        />
      </svg>
    </button>
  )
}
